//src/components/api.js
import axios from "axios";
import { tx } from "../i18n/fieldMapping";
import { isSessionError, notifySessionExpired } from "./SessionExpired";

const api = axios.create({
  baseURL: "https://partners.gotransfer24.de/api",
  withCredentials: true,
});

// ─── Geräte-ID: bindet Login/Session an das GERÄT/den Browser (nicht mehr an den einzelnen Tab) ───────
// Die ID liegt im localStorage: neue Tabs und ein Neustart von Safari/Browser/App bleiben angemeldet, bis man sich abmeldet.
// Fallbacks (localStorage gesperrt, z. B. privater Modus): sessionStorage, zuletzt nur im Speicher.
let memoryId = null;
function getTabId() {
  let id = null;
  try { id = localStorage.getItem('deviceId'); } catch { /* ignorieren */ }
  if (!id) { try { id = sessionStorage.getItem('tabId'); } catch { /* ignorieren */ } } // bestehenden Login dieses Tabs übernehmen
  if (!id) id = memoryId;
  if (!id) id = crypto.randomUUID();
  memoryId = id;
  try { localStorage.setItem('deviceId', id); } catch { /* ignorieren */ }
  try { sessionStorage.setItem('tabId', id); } catch { /* ignorieren */ }
  return id;
}

api.interceptors.request.use((config) => {
  config.headers['X-Tab-Id'] = getTabId();
  return config;
});

// Optional: Automatischer Logout bei 401
// Meldungen des Backends (deutsch) in der gewählten Sprache anzeigen: error/message werden über tx() übersetzt (ohne Eintrag bleibt der Text)
const translateBody = (d) => { if (d && typeof d === "object") { if (typeof d.error === "string") d.error = tx(d.error); if (typeof d.message === "string") d.message = tx(d.message); } };
api.interceptors.response.use(
  response => { translateBody(response?.data); return response; },
  error => {
    translateBody(error?.response?.data);
    if (isSessionError(error)) {
      // Abgelaufene Sitzung: Hinweisseite mit Weg zur Anmeldung (statt „Daten konnten nicht geladen werden“).
      // Bei der allerersten Sitzungsprüfung bzw. auf Anmelde-Seiten bleibt es bei der Weiterleitung.
      if (!notifySessionExpired(error.config?.url) && error.response?.status === 401 && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;